/** frontend specific scripts entrypoint **/

import "bootstrap";
import Modal from "bootstrap/js/dist/modal";
import Swal from "sweetalert2";
import ClipboardJS from "clipboard";
import iro from "@jaames/iro";

$(() => {
    function loadHeaderButton() {
        if (window.location.pathname === '/default/profile' || window.location.pathname === '/default/signup') {
            return;
        }

        $.get("/default/ajax?ajax=get_navigation_info")
            .then((result)=>{
                const res = JSON.parse(result);
                var headerButton = document.getElementById("header-mission-button");

                if (!headerButton) {
                    return;
                }

                let buttonWrapper = document.createElement('div');
                buttonWrapper.className = "me-3";

                let elementChild = '<a class="bg-img-btn white-img" aria-current="page" href="/default/signup">LOG IN</a></div>';

                if (res.is_logged_in) {
                    elementChild = '<a class="bg-img-btn white-img" aria-current="page" href="/default/profile">MY MISSIONS</a></div>';
                }

                buttonWrapper.innerHTML = elementChild;

                headerButton.appendChild(buttonWrapper);
            }
        )
    }

    loadHeaderButton();

    /*** START: Edit/Delete team */
    $(document).on("click", "#delete-team-trigger", function (e) {
        var deleteTeamId = $("#et_team_id").val();

        Swal.fire({
            title: "Are you sure?",
            text: "This will remove everyone from this team",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#4EABD4",
            cancelButtonColor: "#c0d254",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            if (result.value) {
                $.post(
                    "/default/ajax?ajax=delete_team",
                    { team_id: deleteTeamId },
                    function () {
                        window.location.reload();
                    }
                );
            }
        });
    });

    $(document).on("click", ".edit-team-trigger", function (e) {
        const teamId = $(this).attr("data-teamid");
        const teamName = $(this).attr("data-teamname");
        const teamImage = $(this).attr("data-teamimage");
        const teamUpdateImageUrl = `/missions/modify-team-photo/${teamId}`;

        $("#modal-edit-team #et_team_id").val(teamId);
        $("#modal-edit-team #et_team_name").val(teamName);
        $("#modal-edit-team #et_team_image img").attr("src", teamImage);
        $("#modal-edit-team #et_team_image").attr("href", teamUpdateImageUrl);

        let myModal = new Modal(document.getElementById("modal-edit-team"));
        myModal.show();

        e.preventDefault();
    });
    /*** END: Edit/Delete team */

    /*** START: Show modal on load */
    let modalToOpen;
    if (window.openAfterRegistrationModal) {
        modalToOpen = "modal-after-registration";
    } else if (window.openConfirmAddressModal) {
        modalToOpen = "modal-confirmaddress";
    } else if (window.openConfirmedAddressModal) {
        modalToOpen = "modal-confirmedaddress";
    } else if (window.openAwardModal) {
        modalToOpen = "modal-award";
    } else if (window.openPrivateMissionModal) {
        modalToOpen = "modal-private-mission";
    } else if (window.openSuggestCompleteModal) {
        modalToOpen = "modal-suggestcomplete";
    } else if (window.openContinueChainModal) {
        modalToOpen = "modal-continuechain";
    } else if (window.openSponsorMissionReturnModal) {
        modalToOpen = "modal-sponsor-mission-return";
    }

    if (modalToOpen) {
        let modalOnLoad = new Modal(document.getElementById(modalToOpen));
        modalOnLoad.show();
    }
    /*** END: Show modal on load */

    /*** START: Show awards modaL */
    $(document).on("click", ".award-dismiss", function (e) {
        var awardWrapperDiv = $(this).attr("data-wrapper");

        // Send dismissal to server
        $.post("/default/ajax?ajax=dismiss_award", {
            award_allocated_id: $(this).attr("data-id"),
        });

        // Dismiss award
        $(awardWrapperDiv).fadeOut(100, function () {
            // Show next award
            var nextAwardId = parseInt(
                awardWrapperDiv.replace("#award-cont-", "")
            );
            var nextAwardWrapperDiv =
                "#award-cont-" + parseInt(parseInt(nextAwardId) + 1);

            $(nextAwardWrapperDiv).fadeIn(1000);
        });

        e.preventDefault();
    });


    $(document).on("click", ".award-dismiss-all", function (e) {
        e.preventDefault();

        // Send dismissal to server
        $.post("/default/ajax?ajax=dismiss_award_all");

    });

	/*** END: Show awards modal */

    /*** START: ClipboardJS */
    if (ClipboardJS.isSupported()) {
        let clipboard = new ClipboardJS(".clipboarder");

        clipboard.on("success", function (e) {
            let baseHtml = e.trigger.innerHTML;
            e.trigger.innerHTML = "Copied!";

            setTimeout(function () {
                e.trigger.innerHTML = baseHtml;
            }, 5000);
        });

        $(".clipboarder").on("click", function (e) {
            e.preventDefault();
        });
    } else {
        $(".clipboarder").hide();
    }
    /*** END: ClipboardJS */


    /** START: autofocus field in modals **/

    $(".modal").on('shown.bs.modal', function() {
        if (!$(this).find("[autofocus]")[0]) {
            return;
        }
        $(this).find("[autofocus]")[0].focus();
    });

    /** END: autofocus field in modals **/


    /*** START: CONTAINED MODULE: IRO - COLOR PICKER ON MANAGE PLATFORM */
    if ($("#bg-color-picker-container").length > 0) {
        const bgColorPicker = new iro.ColorPicker(
            "#bg-color-picker-container",
            {
                // Set the size of the color picker
                width: 150,
                // Set the initial color to pure red
                color: window.bgColor,
            }
        );

        bgColorPicker.on(["color:change"], function (color) {
            platformBgColor = color.hexString;

            $("input#bg-color-custom").val(window.platformBgColor);
            $("#bg-color-hex-code").val(window.platformBgColor);

            handleCSSChanges();
        });

        // Update fixed/variable cost of stripe_costs[0][cost] on each other change
        $('input[name="stripe_costs[0][cost]"]').on("change", function (e) {
            $('input[name="stripe_costs[0][cost]"]').val(e.target.value);
        });

        $("#bg-color-hex-code-trigger").on("click", function (e) {
            e.preventDefault();

            var changedColor = $("#bg-color-hex-code").val();

            if (changedColor.substr(0, 1) !== "#") {
                changedColor = "#" + changedColor;
            }

            if (/^#[0-9A-F]{6}$/i.test(changedColor)) {
                platformBgColor = changedColor;

                //$('input#bg-color-custom').val(platformBgColor);

                // update color picker
                bgColorPicker.color.set(platformBgColor);

                handleCSSChanges();
            } else {
                //Reset as invalid
                $("#bg-color-hex-code").val($("input#bg-color-custom").val());
            }
        });

        // Dropdown
        $("#bg-color").on("change", function () {
            var changedColor = $(this).val();
            if ($(this).val() === "custom") {
                // Get the value from the custom thingy
                changedColor = $("#bg-color-custom").val();

                $("#text-color").prop("disabled", false).val("");

                $("#bg-color-picker-wrap").slideDown();
            } else {
                if ($(this).val() == "") {
                    $("#text-color").val("").attr("disabled", "disabled");
                    platformTextColor = "";
                } else {
                    $("#text-color").val("").removeAttr("disabled");
                }

                $("#bg-color-picker-wrap").slideUp();
            }

            platformBgColor = changedColor;

            handleCSSChanges();
        });

        $("#text-color").on("change", function () {
            platformTextColor = $(this).val();

            handleCSSChanges();
        });

        handleCSSChanges();
    }

    function handleCSSChanges() {
        const $tabs = $(".mission-tabs .nav-tabs .nav-item .nav-link");
        const $btnsPrimary = $(".small-btn-primary, .solid-bg-btn-primary, .bg-img-btn.blue-img");
        const $btnsSecondary = $(".small-btn-secondary, .solid-bg-btn-secondary");

        // Bg
        $("#mission-info-wrap").css("background", platformBgColor);
        $("body").removeClass("is-platform-bg").addClass("is-platform-bg");
        $(".secondary-color").prop("style", "color: " + platformBgColor + " !important");
        $btnsPrimary.prop("style", "background: " + platformBgColor + " !important");
        $tabs.prop("style", "color: " + platformBgColor + " !important");

        // Text
        $("#mission-profile").css("color", platformTextColor);
        $(".header-burger-menu").prop("style", "background: " + platformTextColor + " !important");
        $(".primary-color").prop("style", "color: " + platformTextColor + " !important");
        $btnsSecondary.prop("style", "background: " + platformTextColor + " !important");
        $tabs.prop("style", "background: " + platformTextColor + " !important");

        if (platformBgColor == "") {
            $("body").removeClass("is-platform-bg");
        } else {
            $("body").removeClass("is-platform-bg").addClass("is-platform-bg");
        }

        if (platformTextColor == "") {
            $("body").removeClass("is-platform-text");
        } else {
            $("body")
                .removeClass("is-platform-text")
                .addClass("is-platform-text");
        }
    }

    /*** END: CONTAINED MODULE: IRO - COLOR PICKER ON MANAGE PLATFORM */

});
